import { render } from "./Defeat.vue?vue&type=template&id=63e987e6"
import script from "./Defeat.vue?vue&type=script&lang=js"
export * from "./Defeat.vue?vue&type=script&lang=js"

import exportComponent from "/Users/corentin/Documents/Projets/Wordle/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__